/// <reference path="../../app.ts" />
/// <reference path="../subcataccordion.ts" />
/// <reference path="../isubcataccordion.ts" />
module Cfnc
{
    "use strict";

    export class PublicPrivates extends SubCatAccordion implements IsubCatAccordion
    {
        selection: string;
        disabled: boolean = true;
        
        typeCbs = [{ type: "Public", isChecked: false },
            { type: "Private", isChecked: false },
            { type: "Religious Private", isChecked: false }
        ];

        religions: string[] = [
            "Adventist",
            "African Methodist-Episcopal",
            "Assembly of God",
            "Baptist",
            "Christian & Missionary Alliance",
            "Christian Science",
            "Church of Christ",
            "Church of God",
            "Church of the Brethren",
            "Congregational( United Church of Christ )",
            "Disciples of Christ",
            "Episcopal( Anglican )",
            "Evangelical",
            "Interdenominational Christian",
            "Jewish",
            "Lutheran",
            "Mennonite",
            "Methodist",
            "Moravian",
            "Mormon",
            "Nondenominational Christian",
            "Other",
            "Other Christian",
            "Plymouth Brethren",
            "Presbyterian",
            "Quaker( Society of Friends )",
            "Reformed",
            "Roman Catholic",
            "Wesleyan",
            "Private/Religious"];

        public getSelectedTypes(): Array<string>
        {
            var selectedTypes = new Array<string>();
            var jsonObj = [];
            this.selected = false;
            for ( var i = 0; i < 2; i++ )
            {
                if ( this.typeCbs[i].isChecked )
                {

                    selectedTypes.push( this.typeCbs[i].type );
                    this.selected = true;
                }
            }
            return selectedTypes;
        }

        public checkPublicPrivateSelected()
        {
            this.selected = false;
            for ( var i in this.typeCbs )
            {
                if ( this.typeCbs[i].isChecked )
                {
                    this.selected = true;
                }
            }
        }
    }
}